module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-72x72.png";